module.exports = __webpack_public_path__ + "img/about_icon_open@2x.295aa0a4.png";